import {
  SmsSurvey,
  HipaaSvg,
  OfflineSurveySVG,
  ResponseManagerSvg,
  SalesforceSvg,
  UnlimitedApi,
  TableauSvg,
  ChimeSvg,
  ColgateSvg,
  PumaLogo,
  AdTestingSvg,
  MaxDiffSvg,
  BrandTrackingSvg,
  PriceOptimizationSvg,
  ConceptTestingSvg,
} from '.';

const { defineMessages } = require('@sm/intl');

const COPY = defineMessages({
  isOfflineModeEnterpriseEnabled: {
    title: 'Offline Surveys',
    body: 'No WiFi? No problem! Conduct field surveys with SurveyMonkey Anywhere app.',
    image: OfflineSurveySVG,
    link: 'https://help.surveymonkey.com/en/surveymonkey/send/offline-mode/',
    desiredProduct: 'offline mode',
    programId: '7014V000002J0E4QAK',
  },

  isResponseManagerEnabled: {
    title: 'Response Manager',
    body: 'Respond to data deletion requests and stay compliant with privacy laws.',
    image: ResponseManagerSvg,
    link: 'https://help.surveymonkey.com/en/surveymonkey/teams/enterprise-settings/#response-manager',
    desiredProduct: 'response manager',
    programId: '7014V000002J0DzQAK',
  },

  smsCollector: {
    title: 'SMS Surveys',
    body: 'Meet your audience where they are by sending them a mobile survey via text.',
    image: SmsSurvey,
    link: 'https://help.surveymonkey.com/en/surveymonkey/send/text-message/',
    programId: '7014V000001yzq9QAA',
    desiredProduct: 'sms surveys',
  },

  isTableauEnabled: {
    title: 'Power BI & Tableau',
    body: 'Automatically import survey responses into your favorite analytics platform.',
    image: TableauSvg,
    link: 'https://help.surveymonkey.com/en/surveymonkey/integrations/#syncing-data',
    programId: '7014V000002dF8qQAE',
    desiredProduct: 'power bi and tableau',
  },

  isUnlimitedApiEnabled: {
    title: 'Unlimited Api Calls',
    body: 'View survey results inside other platforms.',
    image: UnlimitedApi,
    link: 'https://help.surveymonkey.com/en/surveymonkey/integrations/surveymonkey-api/',
    programId: '7014V0000029osMQAQ',
    desiredProduct: 'unlimited api calls',
  },
  isHipaaEnabled: {
    title: 'HIPAA Compliance',
    body: 'Protect the sensitive data your organization collects and ensure patient privacy.',
    image: HipaaSvg,
    link: 'https://help.surveymonkey.com/en/surveymonkey/teams/hipaa/',
    programId: '7014V000002XmJRQA0',
    desiredProduct: 'hipaa compliance',
  },
  isSalesForceEnabled: {
    title: 'Salesforce Integration',
    body: 'Automate workflows and integrate data with easy-to-use Salesforce mapping.',
    image: SalesforceSvg,
    link: 'https://help.surveymonkey.com/en/surveymonkey/integrations/surveymonkey-salesforce-app/',
    programId: '7014V000001yzq9QAA',
    desiredProduct: 'salesforce integration',
  },
  chimeTestimonial: {
    logo: { img: ChimeSvg, height: '32px', width: '72px' },
    body: '“Momentive managed to capture the nuance to diversity, equity, and belonging work, moving beyond the surface level - they helped us achieve a higher level of understanding.”',
    quottedPerson: 'Erica Johnson',
    company: 'Chime',
  },
  pumaTestimonial: {
    logo: { img: PumaLogo, height: '30px', width: '60px' },
    body: "“It's been a fun experience because I've been able to leverage the feedback we get in a much more thoughtful manner and ensure that it falls in line with what our customers want.”",
    quottedPerson: 'Joey CasaDeCalvo',
    company: 'Puma',
  },
  colgateTestimonial: {
    logo: { img: ColgateSvg, height: '32px', width: '60%' },
    body: '“We were really impressed with the level of service from the Momentive team. It felt like a spa treatment. It felt very customized, very intensive, very supportive. That was surprising and delightful.”',
    quottedPerson: 'Mike Fitzgerald',
    company: 'Colgate-Palmolive',
  },
  conceptTesting: {
    title: 'Concept Testing',
    body: 'Validate and optimize product concepts with your target audience and compare against industry benchmarks.',
    image: { img: ConceptTestingSvg, height: '110px', width: '102px' },
    ctaLink: '/solutions/create/511',
    learnMoreLink: 'https://help.surveymonkey.com/en/surveymonkey/solutions/concept-testing/',
    desiredProduct: 'concept testing',
  },
  adTesting: {
    title: 'Ad Testing',
    body: 'Test ad creatives before they launch to maximize campaign effectiveness.',
    image: { img: AdTestingSvg, height: '127px', width: '160px' },
    ctaLink: '/solutions/create/506',
    learnMoreLink: 'https://www.surveymonkey.com/market-research/solutions/ad-creative-analysis/',
    desiredProduct: 'ad testing',
  },
  brandTracking: {
    title: 'Brand Tracking',
    body: 'Fuel your brand strategy with continuous insights on top performance metrics including awareness, perception, loyalty, and more.',
    image: { img: BrandTrackingSvg, height: '111px', width: '186px' },
    ctaLink: '/market-research/solutions/brand-tracker/',
    learnMoreLink: 'https://www.surveymonkey.com/market-research/solutions/brand-tracker/',
    desiredProduct: 'brand tracking',
  },
  priceOptimization: {
    title: 'Price Optimization',
    body: 'Find the optimal price range for your product or service using the Van Westendorp model.',
    image: { img: PriceOptimizationSvg, height: '145px', width: '158px' },
    ctaLink: '/solutions/mrx/van_westendorp/studies/create/',
    learnMoreLink: 'https://help.surveymonkey.com/en/surveymonkey/solutions/van-westendorp/',
    desiredProduct: 'price optimization',
  },
  maxDiff: {
    title: 'Feature Importance (MaxDiff)',
    body: 'Understand which product features influence decisions and satisfaction the most with advanced MaxDiff analysis.',
    image: { img: MaxDiffSvg, height: '120px', width: '150px' },
    ctaLink: '/market-research/services/',
    desiredProduct: 'feature importance',
    learnMoreLink:
      'https://www.surveymonkey.com/market-research/resources/feature-importance-research-product-success/',
  },
});

export default COPY;
